
export enum RatingWhatIfRequestStatusCd {
	COMPLETED = 'Completed',
	ERROR = 'Error',
	IN_PROGRESS = 'InProgress',
	OPEN = 'Open'}
